import styled, { css } from 'styled-components';
import { Typography } from 'src/typography';

const SharedContainerStyles = css`
  ${({
    theme: {
      colors,
      spaces,
      customized: { radius },
    },
  }) => css`
    display: flex;
    background: ${colors.grey[95]};
    border-radius: 0 0 ${radius.md} ${radius.md};
    width: 100%;

    /* Smooth slide-down entrance */
    animation: slideDownFade 0.4s cubic-bezier(0.16, 1, 0.3, 1);

    @keyframes slideDownFade {
      0% {
        max-height: 0;
        opacity: 0;
        padding-top: 0;
        padding-bottom: 0;
      }
      100% {
        max-height: 300px;
        opacity: 1;
        padding-top: ${spaces[4]};
        padding-bottom: ${spaces[4]};
      }
    }
  `}
`;

export const DesktopContainer = styled.div`
  ${SharedContainerStyles}
  padding: ${({ theme }) => theme.spaces[4]};
  justify-content: center;
  align-items: center;
  gap: ${({ theme: { spaces } }) => spaces[6]};
  align-self: stretch;
`;

export const MobileContainer = styled.div`
  ${SharedContainerStyles}
  flex-direction: column;
  padding: ${({ theme: { spaces } }) => spaces[4]};
  overflow: hidden;
  gap: ${({ theme: { spaces } }) => spaces[4]};
  width: 100%;
`;

export const ContentRow = styled.div`
  display: flex;
  gap: ${({ theme: { spaces } }) => spaces[4]};
  align-items: center;
`;

export const SVGWrapper = styled.div`
  svg {
    display: block;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme: { spaces } }) => spaces[2]};
  align-self: stretch;
`;

export const Title = styled(Typography.Title)`
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

export const Description = styled(Typography.Body)`
  color: ${({ theme }) => theme.colors.grey[30]};
  letter-spacing: 0.065px;
`;
